import Duck from 'extensible-duck'

const selectors = () => ({
    getClaim: new Duck.Selector(() => (state) => state?.data?.claim),
    getOutboundClaim: new Duck.Selector(() => (state) => state?.outboundClaim),
    getTokens: new Duck.Selector(() => (state) => state?.claim?.data),
})

export default selectors
